export enum ConsumerProfileErrorCode {
  InvalidCanadianPhoneNumber = 'INVALID_CANADIAN_PHONE_NUMBER',
  IncorrectVerificationCode = 'INCORRECT_VERIFICATION_CODE',
  VerificationAttemptsExhausted = 'VERIFICATION_ATTEMPTS_EXHAUSTED',
  UpdatePhoneNumberAttemptsExhausted = 'UPDATE_PHONE_NUMBER_ATTEMPTS_EXHAUSTED',
  ResetVerificationCodeAttemptsExhausted = 'RESET_VERIFICATION_CODE_ATTEMPTS_EXHAUSTED',
  VerificationCodeExpired = 'VERIFICATION_CODE_EXPIRED'
}
